export const COMMIT_UPDATE_USERNAME = 'updateUsername'
export const COMMIT_SET_STATUS = 'setStatus'
export const COMMIT_FETCH_MESSAGES = 'fetchMessages'
export const COMMIT_FETCH_USERS = 'fetchUsers'
export const COMMIT_FETCH_CONTACTS = 'fetchContacts'
export const COMMIT_FETCH_IMAGES = 'fetchImages'
export const COMMIT_ADD_IMAGE = 'addImage'
export const COMMIT_SET_USERS = 'setUsers'
export const COMMIT_SET_IMAGES = 'setImages'
export const COMMIT_UPDATE_MESSAGE = 'updateMessage'
export const COMMIT_ADD_VIEWED = 'addViewed'
export const COMMIT_FETCH_CHANNELS = 'fetchChannel'
export const COMMIT_NEW_CHANNEL = 'newChannel'
export const COMMIT_UPDATE_USER = 'updateUser'
export const LISTENER_ACTIVE_USERS = 'activeUsers'
export const LISTENER_NEW_MESSAGE = 'newMessage'
export const LISTENER_SET_MESSAGE = 'setMessage'
export const LISTENER_CHANNEL_ACTIVE = 'channelActive'
export const LISTENER_SET_MESSAGE_CHAT = 'setMessageChat' 
export const TOGGLE_LOADING = 'toggleLoading'
export const HISTORY_MESSAGES = 'historyMessages'
